const FALCON_DASHBOARD_CONSTANTS = {
  // CLIENT DASHBOARDS
  GET_FALCON_CLIENTS: 'GET_FALCON_CLIENTS',
  GET_FALCON_CLIENTS_SUCCESS: 'GET_FALCON_CLIENTS_SUCCESS',
  GET_FALCON_CLIENTS_FAILURE: 'GET_FALCON_CLIENTS_FAILURE',
  GET_FALCON_CLIENT_DETAILS: 'GET_FALCON_CLIENT_DETAILS',
  GET_FALCON_CLIENT_DETAILS_SUCCESS: 'GET_FALCON_CLIENT_DETAILS_SUCCESS',
  GET_FALCON_CLIENT_DETAILS_FAILURE: 'GET_FALCON_CLIENT_DETAILS_FAILURE',
  CREATE_FALCON_CLIENT: 'CREATE_FALCON_CLIENT',
  CREATE_FALCON_CLIENT_SUCCESS: 'CREATE_FALCON_CLIENT_SUCCESS',
  CREATE_FALCON_CLIENT_FAILURE: 'CREATE_FALCON_CLIENT_FAILURE',
  UPDATE_FALCON_CLIENT: 'UPDATE_FALCON_CLIENT',
  UPDATE_FALCON_CLIENT_SUCCESS: 'UPDATE_FALCON_CLIENT_SUCCESS',
  UPDATE_FALCON_CLIENT_FAILURE: 'UPDATE_FALCON_CLIENT_FAILURE',

  UPDATE_FALCON_CLIENT_PAYOUT_PARTNERS: 'UPDATE_FALCON_CLIENT_PAYOUT_PARTNERS',
  UPDATE_FALCON_CLIENT_PAYOUT_PARTNERS_SUCCESS:
    'UPDATE_FALCON_CLIENT_PAYOUT_PARTNERS_SUCCESS',
  UPDATE_FALCON_CLIENT_PAYOUT_PARTNERS_FAILURE:
    'UPDATE_FALCON_CLIENT_PAYOUT_PARTNERS_FAILURE',
  // Falcon Client Balance Manager
  GET_FALCON_CLIENT_BALANCE_DETAILS: 'GET_FALCON_CLIENT_BALANCE_DETAILS',
  GET_FALCON_CLIENT_BALANCE_DETAILS_SUCCESS:
    'GET_FALCON_CLIENT_BALANCE_DETAILS_SUCCESS',
  GET_FALCON_CLIENT_BALANCE_DETAILS_FAILURE:
    'GET_FALCON_CLIENT_BALANCE_DETAILS_FAILURE',
  UPDATE_FALCON_CLIENT_BALANCE: 'UPDATE_FALCON_CLIENT_BALANCE',
  GETTING_FALCON_CLIENT_BALANCE_HISTORY:
    'GETTING_FALCON_CLIENT_BALANCE_HISTORY',
  GET_FALCON_CLIENT_BALANCE_HISTORY_SUCCESS:
    'GET_FALCON_CLIENT_BALANCE_HISTORY_SUCCESS',
  GET_FALCON_CLIENT_BALANCE_HISTORY_FAILURE:
    'GET_FALCON_CLIENT_BALANCE_HISTORY_FAILURE',
  UPDATE_FALCON_CLIENT_CREDIT_LINE_BALANCE: 'UPDATE_FALCON_CLIENT_CREDIT_LINE_BALANCE',

  // TRANSACTION DASHBOARDS
  UPDATE_FALCON_TRANSACTION_DASHBOARD_REQ_DATA:
    'UPDATE_FALCON_TRANSACTION_DASHBOARD_REQ_DATA',
  GET_FALCON_TRANSACTIONS: 'GET_FALCON_TRANSACTIONS',
  GET_FALCON_TRANSACTIONS_SUCCESS: 'GET_FALCON_TRANSACTIONS_SUCCESS',
  GET_FALCON_TRANSACTIONS_FAILURE: 'GET_FALCON_TRANSACTIONS_FAILURE',

  GET_TRANSACTION_DETAILS: 'GET_TRANSACTION_DETAILS',
  GET_TRANSACTION_DETAILS_SUCCESS: 'GET_TRANSACTION_DETAILS_SUCCESS',
  GET_TRANSACTION_DETAILS_FAILURE: 'GET_TRANSACTION_DETAILS_FAILURE',
  GET_TRANSACTION_FILTERS: 'GET_TRANSACTION_FILTERS',
  GET_TRANSACTION_FILTERS_SUCCESS: 'GET_TRANSACTION_FILTERS_SUCCESS',
  GET_TRANSACTION_CONFIGS: 'GET_TRANSACTION_CONFIGS',
  GET_TRANSACTION_CONFIGS_SUCCESS: 'GET_TRANSACTION_CONFIGS_SUCCESS',
  UPDATE_LAST_FALCON_TRANSACTION_PAYOUT_DETAILS:
    'UPDATE_LAST_FALCON_TRANSACTION_PAYOUT_DETAILS',
  // Force Sync
  FORCE_SYNC_TRANSACTION: 'FORCE_SYNC_TRANSACTION',
  FORCE_SYNC_TRANSACTION_SUCCESS: 'FORCE_SYNC_TRANSACTION_SUCCESS',
  // Force Update On Hold Txn 
  FORCE_UPDATE_ON_HOLD_TXN_STATUS: 'FORCE_UPDATE_ON_HOLD_TXN_STATUS',
  FORCE_UPDATE_ON_HOLD_TXN_STATUS_SUCCESS:
    'FORCE_UPDATE_ON_HOLD_TXN_STATUS_SUCCESS',
  
  // Force Fail Txn
  FORCE_FAIL_TRANSACTION: 'FORCE_FAIL_TRANSACTION',
  FORCE_FAIL_TRANSACTION_SUCCESS: 'FORCE_FAIL_TRANSACTION_SUCCESS',
  // Force Complete Txn
  FORCE_PROCESS_TRANSACTION: 'FORCE_PROCESS_TRANSACTION',
  FORCE_PROCESS_TRANSACTION_SUCCESS: 'FORCE_PROCESS_TRANSACTION_SUCCESS',
  // Set Terminal State
  SET_TERMINAL_STATE: 'SET_TERMINAL_STATE',
  SET_TERMINAL_STATE_SUCCESS: 'SET_TERMINAL_STATE_SUCCESS',

  GET_TRANSACTION_COMPONENTS: 'GET_TRANSACTION_COMPONENTS',
  GET_TRANSACTION_COMPONENTS_SUCCESS: 'GET_TRANSACTION_COMPONENTS_SUCCESS',

  // VENDOR DASHBOARD
  GET_FALCON_VENDORS: 'GET_FALCON_VENDORS',
  GET_FALCON_VENDORS_SUCCESS: 'GET_FALCON_VENDORS_SUCCESS',
  GET_FALCON_VENDORS_FAILURE: 'GET_FALCON_VENDORS_FAILURE',
  GET_FALCON_VENDOR_DETAILS: 'GET_FALCON_VENDOR_DETAILS',
  GET_FALCON_VENDOR_DETAILS_SUCCESS: 'GET_FALCON_VENDOR_DETAILS_SUCCESS',
  GET_FALCON_VENDOR_DETAILS_FAILURE: 'GET_FALCON_VENDOR_DETAILS_FAILURE',
  UPDATE_FALCON_VENDORS_DASHBOARD_VIEW_MODE:
    'UPDATE_FALCON_VENDORS_DASHBOARD_VIEW_MODE',
  CREATE_FALCON_VENDOR: 'CREATE_FALCON_VENDOR',
  CREATE_FALCON_VENDOR_SUCCESS: 'CREATE_FALCON_VENDOR_SUCCESS',
  CREATE_FALCON_VENDOR_FAILURE: 'CREATE_FALCON_VENDOR_FAILURE',
  UPDATE_FALCON_VENDOR: 'UPDATE_FALCON_VENDOR',
  UPDATE_FALCON_VENDOR_SUCCESS: 'UPDATE_FALCON_VENDOR_SUCCESS',
  UPDATE_FALCON_VENDOR_FAILURE: 'UPDATE_FALCON_VENDOR_FAILURE',

  GET_DASHBOARD_CONFIG: 'GET_DASHBOARD_CONFIG',
  GET_DASHBOARD_CONFIG_SUCCESS: 'GET_DASHBOARD_CONFIG_SUCCESS',
  GET_DASHBOARD_CONFIG_FAILURE: 'GET_DASHBOARD_CONFIG_FAILURE',

  // RFI TRANSACTION DASHBOARD
  GET_RFI_TRANSACTIONS: 'GET_RFI_TRANSACTIONS',
  GET_RFI_TRANSACTIONS_SUCCESS: 'GET_RFI_TRANSACTIONS_SUCCESS',
  GET_RFI_TRANSACTIONS_FAILURE: 'GET_RFI_TRANSACTIONS_FAILURE',
  GET_RFI_TRANSACTION_DETAILS: 'GET_RFI_TRANSACTION_DETAILS',
  GET_RFI_TRANSACTION_DETAILS_SUCCESS: 'GET_RFI_TRANSACTION_DETAILS_SUCCESS',
  GET_RFI_TRANSACTION_DETAILS_FAILURE: 'GET_RFI_TRANSACTION_DETAILS_FAILURE',
  SUBMITTED_TO_PARTNER: 'SUBMITTED_TO_PARTNER',
  SUBMITTED_TO_PARTNER_SUCCESS: 'SUBMITTED_TO_PARTNER_SUCCESS',
  SUBMITTED_TO_PARTNER_FAILURE: 'SUBMITTED_TO_PARTNER_FAILURE',
  REJECTED_BY_PARTNER: 'REJECTED_BY_PARTNER',
  REJECTED_BY_PARTNER_SUCCESS: 'REJECTED_BY_PARTNER_SUCCESS',
  REJECTED_BY_PARTNER_FAILURE: 'REJECTED_BY_PARTNER_FAILURE',
  SUBMIT_RFI_DOCUMENTS: 'SUBMIT_RFI_DOCUMENTS',
  SUBMIT_RFI_DOCUMENTS_SUCCESS: 'SUBMIT_RFI_DOCUMENTS_SUCCESS',
  SUBMIT_RFI_DOCUMENTS_FAILURE: 'SUBMIT_RFI_DOCUMENTS_FAILURE',

  // ANALYTICS DASHBOARD
  GETTING_ANALYTICS_DATA: 'GETTING_ANALYTICS_DATA',
  GETTING_ANALYTICS_DATA_SUCCESS: 'GETTING_ANALYTICS_DATA_SUCCESS',
  GETTING_ANALYTICS_DATA_FAILURE: 'GETTING_ANALYTICS_DATA_FAILURE',
  GETTING_VALIDATION_HISTORY: 'GETTING_VALIDATION_HISTORY',
  GETTING_VALIDATION_HISTORY_SUCCESS: 'GETTING_VALIDATION_HISTORY_SUCCESS',
  GETTING_VALIDATION_HISTORY_FAILURE: 'GETTING_VALIDATION_HISTORY_FAILURE',
  GETTING_VALIDATION_HISTORY_COMPONENTS: 'GETTING_VALIDATION_HISTORY_COMPONENTS',
  GETTING_VALIDATION_HISTORY_COMPONENTS_SUCCESS: 'GETTING_VALIDATION_HISTORY_COMPONENTS_SUCCESS',
};

export default FALCON_DASHBOARD_CONSTANTS;
